<router-outlet>
  <app-spinner></app-spinner>
  <app-toast></app-toast>
</router-outlet>
